/**
 * Admin-tenant gate for UI controls that admins may author but regular
 * tenants may not — currently the Public/Private visibility selector on
 * component-rule creation.
 *
 * Returns `true` when the current admin user's active session has the
 * `'admin'` role. Non-authenticated sessions and users without the role
 * return `false`.
 *
 * Kept as a separate hook from {@link useIsConfigModeEligible} even
 * though the underlying signal overlaps today: the two gates can diverge
 * later (for example, a finer-grained `'rule-publisher'` role) without
 * cross-impact if each call site keeps its own hook.
 */

import { ADMIN_ROLE } from '@components/shared/configurable';
import { useAdminAuthStore } from './store';

export function useIsAdminTenant(): boolean {
  const user = useAdminAuthStore((state) => state.user);
  const isAuthenticated = useAdminAuthStore((state) => state.isAuthenticated);
  if (!isAuthenticated || !user) return false;
  return user.roles.includes(ADMIN_ROLE);
}
